import { ViewListIcon, ViewGridIcon } from '@heroicons/react/outline';
import { useState } from 'react';
import clsx from 'clsx';

export default function SwitchButton({ setSwitch }) {
  let [isSelected, setIsSelectes] = useState(false);

  const handleSwitch = (isSelected) => {
    setSwitch(isSelected);
    setIsSelectes(isSelected);
  };

  return (
    <div className="ml-6  items-center rounded-lg bg-gray-100 p-0.5 sm:flex">
      <button
        onClick={() => handleSwitch(!isSelected)}
        type="button"
        className={clsx(
          isSelected ? 'bg-white text-gray-500' : 'text-gray-400 hover:bg-white',
          'ml-0.5 rounded-md  p-1.5  shadow-sm focus:outline-none focus:ring-2 focus:ring-inset focus:ring-teal-500'
        )}
      >
        <ViewListIcon className="h-5 w-5" aria-hidden="true" />
        <span className="sr-only">Use list view</span>
      </button>
      <button
        onClick={() => handleSwitch(!isSelected)}
        type="button"
        className={clsx(
          !isSelected ? 'bg-white text-gray-500' : 'text-gray-400 hover:bg-white',
          'ml-0.5 rounded-md  p-1.5 shadow-sm focus:outline-none focus:ring-2 focus:ring-inset focus:ring-teal-500'
        )}
      >
        <ViewGridIcon className="h-5 w-5" aria-hidden="true" />
        <span className="sr-only">Use grid view</span>
      </button>
    </div>
  );
}
